module.exports = __webpack_public_path__ + "img/ArrowWhite.60d9cace.png";